export var reCAPTCHA = {
  siteKey:'6LcWHQIpAAAAAARzAEMYhv3kvoYfcTeFpJuGAL3l'
};